import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

export const SUPABASE_ENABLED = Boolean(supabaseUrl && supabaseAnonKey)

if (!SUPABASE_ENABLED) {
  // Soft warning for missing envs in local dev; avoids crashing the app.
  // eslint-disable-next-line no-console
  console.warn('Supabase disabled: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to enable real auth')
}

export const supabase = createClient(supabaseUrl || 'http://localhost', supabaseAnonKey || 'anon')

export type AppRole = 'basic' | 'premium' | 'exclusive' | 'admin'

export interface ProfileRow {
  id: string
  email: string
  display_name: string | null
  role: AppRole
  created_at: string
  updated_at: string
}

